import { render, staticRenderFns } from "./InstallButton.vue?vue&type=template&id=a949d55e"
import script from "./InstallButton.vue?vue&type=script&lang=js"
export * from "./InstallButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports